import {call, put, takeEvery, takeLatest} from "redux-saga/effects";

// Login Redux States
import {LoginTypes} from "./actionTypes";
import {apiError, loginSuccess, logoutUserSuccess} from "./actions";

import {
    postJwtLogin,
} from "../../../helpers/backend_helper";
import { clearAuthUser, setAuthUser } from "../../../helpers/auth";

function* loginUser({payload: {user, history}}: any) {
    try {
        const response: Promise<any> = yield call(postJwtLogin, {
            email: user.email,
            password: user.password,
        });

        yield put(loginSuccess(response));

        const authUser = {
            // @ts-ignore
            "token_type": response?.token_type,
            // @ts-ignore
            "token": response?.token,
            // @ts-ignore
            "roles": response?.roles,
            // @ts-ignore
            "office_ids": response?.office_ids,
            // @ts-ignore
            "user_id": response?.user_id,
            // @ts-ignore
            "team_id": response?.team_id,
            // @ts-ignore
            "username": response?.name,
            // @ts-ignore
            "email": response?.email
        };
        setAuthUser(authUser);

        history("/dashboard");
    } catch (error) {
        yield put(apiError(error));
    }
}

function* logoutUser({payload: {history, unsubscribeFromChannels}}: any) {
    try {
        if (unsubscribeFromChannels) {
            unsubscribeFromChannels();
        }

        yield put(logoutUserSuccess(null));

        clearAuthUser();

        // history.push("/login");
    } catch (error) {
        yield put(apiError(error));
    }
}


function* authSaga() {
    yield takeEvery(LoginTypes.LOGIN_USER, loginUser);
    yield takeEvery(LoginTypes.LOGOUT_USER, logoutUser);
}

export default authSaga;
